import { JourneyFeatureFlags as FeatureFlags } from '@epilot/journey-logic-commons'

import { useAppStoreSelector } from '../../hooks/useAppStoreSelector'
import { useFlag } from '../../hooks/useFlags'
import { selectConcordeEnabled } from '../../store/selectors/config'

import { ConcordeJourneyLauncherTabs } from './ConcordeJourneyLauncherTabs'
import { LegacyJourneyLauncherTabs } from './LegacyJourneyLauncherTabs'
import type { BaseJourneyLauncherTabsProps } from './types'

export const JourneyLauncherTabs = (props: BaseJourneyLauncherTabsProps) => {
  const concordeEnabled = useAppStoreSelector(selectConcordeEnabled)
  const concordeLauncherEnabled = useFlag(
    FeatureFlags.CONCORDE_JOURNEY_LAUNCHER
  )

  return concordeEnabled && concordeLauncherEnabled ? (
    <ConcordeJourneyLauncherTabs {...props} />
  ) : (
    <LegacyJourneyLauncherTabs {...props} />
  )
}
